export const metrics = {
  drawerWidth: 60,
}